module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-36.7cbc5758.png";